import { render, staticRenderFns } from "./JCodeEditor.vue?vue&type=template&id=04f8f823"
import script from "./JCodeEditor.vue?vue&type=script&lang=js"
export * from "./JCodeEditor.vue?vue&type=script&lang=js"
import style0 from "./JCodeEditor.vue?vue&type=style&index=0&id=04f8f823&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f8f823')) {
      api.createRecord('04f8f823', component.options)
    } else {
      api.reload('04f8f823', component.options)
    }
    module.hot.accept("./JCodeEditor.vue?vue&type=template&id=04f8f823", function () {
      api.rerender('04f8f823', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JCodeEditor.vue"
export default component.exports